module.exports = __webpack_public_path__ + "static/media/group_guide_img_1.ef788a19.png";